module.exports = __webpack_public_path__ + "img/logo-color.60154ae2.svg";